import { CoverType } from '../cover';

export interface Industry {
  industryCode: string;
  industryValue: string;
  industryPriority: number;
  underwritingStatus?: UnderwritingStatus;
  limits?: {
    noOfEmployees?: number;
    turnover?: number;
    estCostOfContractors?: number;
    specifiedItemMin?: number;
    totalPortableItemSumInsured?: number;
    floodRatingZone?: number;
    propertyValue?: number;
  };
}

export interface OccupationCategory {
  categoryCode: string;
  categoryDescription: string;
  groupPriority: number;
  anzsicPriority: number;
  underwritingStatus?: UnderwritingStatus;
}

export interface Occupation {
  anzsicCode: string;
  anzsicPriority: number;
  occupation: string;
  groupPriority: number;
  underwritingStatus?: UnderwritingStatus;
  propertyOwnerAnzsic?: string;
}

export interface OccupationsListItem {
  industryCode: string;
  industryValue: string;
  categoryCode: string;
  categoryValue: string;
  code: string;
  desc: string;
  /* eslint-disable-next-line camelcase */
  uw_status?: UnderwritingStatus;
  propertyOwnerAnzsic?: string;
  anzsicShortDescription?: string;
}

export interface HistoryQuestion {
  questionId: string;
  questionText: string;
  productCode: string;
  riskCode: string;
  questionGroupId: number;
  questionGroupText: string;
}

export interface HistoryAnswers {
  id: string;
  answer?: boolean;
}

export interface RefDataCover {
  cover: CoverType;
  priority: number;
  description: string;
  riskClass: string;
  premiumClass: string;
  industryCode: string;
}

export enum UnderwritingStatus {
  Decline = 'DECLINE',
  Refer = 'REFER',
}

export enum OccupationSearchType {
  Icon = 'Icon',
  QuickSearch = 'QuickSearch',
}

export const occupationListItemToOccupation = (item: OccupationsListItem): Occupation => ({
  anzsicCode: item.code,
  anzsicPriority: 1,
  occupation: item.desc,
  groupPriority: 1,
  underwritingStatus: item.uw_status,
  propertyOwnerAnzsic: item.propertyOwnerAnzsic,
});
